import styled from 'styled-components';

export const SearchTabContainer = styled.div`
  max-width: 1080px;

  form {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 30px 0 30px;

    &.is-hide {
      .hide {
        display: none;
      }
    }

    @media screen and (max-width: 1080px) {
      justify-content: space-between;
    }

    @media screen and (max-width: 512px) {
      padding: 16px 16px 0 16px;
    }
  }

  .proposals {
    padding-bottom: 12px;
  }

  .more-btn {
    padding: 0 30px 16px 30px;
    display: flex;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    @media screen and (max-width: 512px) {
      padding-top: 14px;
      position: relative;
      justify-content: center;

      &::before {
        position: absolute;
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: ${({ theme }) => theme.colors.color_bluegray};
        opacity: 0.2;
        top: 0;
        left: 0;
      }
    }
  }

  .select-advert-type {
    display: none;
    width: 100%;
  }

  .checkbox-items {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .item {
      margin-right: 24px;
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 1080px) {
    .price-block {
      order: 6;
    }

    .checkbox-items {
      order: 7;
    }

    .price-block.rent {
      .period-types {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 850px) {
    .select-advert-type {
      display: block;
    }
  }

  @media screen and (max-width: 512px) {
    .price-block {
      order: 6;
    }
    .checkbox-items {
      flex-direction: column;
    }
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-end;
  margin-right: 20px;
  padding-bottom: 21px;

  @media screen and (max-width: 1080px) {
    padding: 0;
    margin: 0 0 12px 0;
    width: 49%;
    align-items: inherit;
  }

  @media screen and (max-width: 512px) {
    width: 100%;
  }
`;
